module.exports = __webpack_public_path__ + "static/media/foto-monse.64d09495.jpg";